import { LessonContentResources } from '@/services/lessonContents/types';

export enum EventType {
  ContentOpened = 'content_opened',
  ContentClosed = 'content_closed',
  InteractiveOpened = 'interactive_opened',
  NotebookOpened = 'notebook_opened',

  // USER ACTIVITY EVENTS
  ActiveStatus = 'active_status',
}

export enum ContentType {
  Video = LessonContentResources.video,
  Podcast = LessonContentResources.podcast,
  MindMap = LessonContentResources.mindMap,
  Discover = LessonContentResources.discover,
  AiMaterial = LessonContentResources.aiMaterial,
  TeachersGuide = LessonContentResources.teachersGuide,
  Pdf = LessonContentResources.pdf,
  Interactive = LessonContentResources.interactive,
}

export interface IEventRequest {
  contentID?: string;
  contentType?: ContentType;
  duration?: number;
  eventType?: EventType;
  moduleName?: string;
}

export const TRACKING_DELAY = {
  VIDEO: 180,
} as const;

export const CONTENT_TYPE_EVENT_MAPPING: Record<ContentType, EventType> = {
  [ContentType.Video]: EventType.ContentOpened,
  [ContentType.Discover]: EventType.ContentOpened,
  [ContentType.Podcast]: EventType.ContentOpened,
  [ContentType.MindMap]: EventType.ContentOpened,
  [ContentType.Pdf]: EventType.NotebookOpened,
  [ContentType.Interactive]: EventType.InteractiveOpened,
  [ContentType.AiMaterial]: EventType.ContentOpened,
  [ContentType.TeachersGuide]: EventType.ContentOpened,
};

export const getEventTypeForContentType = (
  contentType: ContentType
): EventType => {
  return CONTENT_TYPE_EVENT_MAPPING[contentType];
};

export const getContentTypeForResource = (
  resource: LessonContentResources
): ContentType => {
  const contentType = Object.values(ContentType).find(
    (contentType) => contentType.toLowerCase() === resource.toLowerCase()
  );
  if (!contentType) {
    throw new Error(`Content type not found for resource: ${resource}`);
  }
  return contentType;
};

/**
 * Content type ve duration'a göre tracking delay gerekip gerekmediğini belirler
 * @param contentType - İçerik tipi
 * @param duration - İçerik süresi (saniye)
 * @returns shouldDelay - Delay gerekip gerekmediği
 */
export const shouldDelayTracking = (
  contentType: ContentType,
  duration: number
): boolean => {
  // Video (Konu Anlatım, Keşfet) ve Podcast için: 3 dakikadan kısa ise hemen gönder, uzunsa delay ile gönder
  if (
    contentType === ContentType.Video ||
    contentType === ContentType.Discover ||
    contentType === ContentType.Podcast
  ) {
    return duration >= TRACKING_DELAY.VIDEO;
  }

  // Kavram Haritası, İnteraktif içerikler ve diğerleri için: Açıldığı anda hemen gönder (delay yok)
  return false;
};
